export default "__VITE_ASSET__CXvvl8U___"